import React from 'react';
import { NavLink } from "react-router-dom";

import PropTypes from "prop-types";

import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Avatar from "@material-ui/core/Avatar";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";

import MenuIcon from "@material-ui/icons/Menu";
import Button from "components/CustomButtons";

import useUser from "hooks/useUser";
import useLogin from "hooks/useLogin";

import styles from "assets/jss/components/navbarStyle.js";
import useProject from "hooks/useProject";
const useStyles = makeStyles(styles);

export default function Header(props) {
  const userHook = useUser();
  const loginHook = useLogin();
  const projectHook = useProject();
  const classes = useStyles();

  const handleLogout=()=> {
    loginHook.logout();
  };

  const profile = userHook.me.profile || {} ;
  const projectName = projectHook.project ? projectHook.project.displayName : '';

  return (
    <AppBar className={classes.appBar}>
      <Toolbar className={classes.toolBar}>
        <Hidden smDown implementation="css">
          <div className={classes.flexBox}>
            <NavLink to={"/"} activeClassName="active" className={classes.link}>
              <Typography variant="h5" noWrap>WebViewer 管理システム - {projectName}</Typography>
            </NavLink>
          </div>
        </Hidden>
        <Hidden mdUp implementation="css">
          <div className={classes.flexBox}>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={props.handleDrawerToggle}
              className={classes.menuIcon}
            >
              <MenuIcon />
            </IconButton>

            <NavLink to={"/"} activeClassName="active" className={classes.link}>
              <Typography variant="h5" noWrap>WebViewer 管理システム</Typography>
            </NavLink>
          </div>
        </Hidden>
        <div className={classes.flexBox}>
          <Avatar src={`${profile.picture}`} className={classes.small} />
          <div className={classes.profileName}>
            <div className={classes.name}>{profile.name}</div>
            <div className={classes.email}>{profile.email}</div>
          </div>
          <Button color="info" onClick={()=> handleLogout()} className={classes.logout}>ログアウト</Button>
        </div>
      </Toolbar>
    </AppBar>
  );
}

Header.propTypes = {
  handleDrawerToggle: PropTypes.func,
  routes: PropTypes.arrayOf(PropTypes.object)
};
